import { render, staticRenderFns } from "./BlockType115.vue?vue&type=template&id=7acf6e96&scoped=true"
import script from "./BlockType115.vue?vue&type=script&lang=ts"
export * from "./BlockType115.vue?vue&type=script&lang=ts"
import style0 from "./BlockType115.vue?vue&type=style&index=0&id=7acf6e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acf6e96",
  null
  
)

export default component.exports